import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const CUSTOMER_DATA_SERVICE = new InjectionToken<CustomerDataService>('CustomerDataService');

export interface CustomerData {
  customerId: string;
  companyName: string;
}

export interface CustomerDataService {
  get(customerId: string): Observable<CustomerData>;

  getMulti(customerIds: string[]): Observable<CustomerData[]>;
}
